import { InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { CookieService } from 'ngx-cookie-service';
import isEmpty from 'lodash-es/isEmpty';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "ngx-cookie-service/cookie-service/cookie.service";
export var GEO_LOCATION_CONFIG = new InjectionToken('GEO_LOCATION_CONFIG');
var GeolocationService = /** @class */ (function () {
    function GeolocationService(config, httpClient, cookieService) {
        this.config = config;
        this.httpClient = httpClient;
        this.cookieService = cookieService;
        this.url = this.config.URL;
    }
    GeolocationService.prototype.getGeoCode = function () {
        var _this = this;
        var cookieAka = this.cookieService.get(this.config.COOKIE_AKA);
        var cookieJar = this.cookieService.get(this.config.COOKIE_JAR);
        if (!isEmpty(cookieAka)) {
            console.log('geolocation using aka', this.config.COOKIE_AKA);
            return this.getGeoFromAkamaiCookie(cookieAka);
        }
        else if (!isEmpty(cookieJar)) {
            console.log('geolocation using jar', this.config.COOKIE_JAR);
            return this.getGeoFromCookie(cookieJar);
        }
        else {
            console.log('geolocation using url', this.url);
            if (this.geoDataCache) {
                console.log('geo: return the cached geo data');
                return of(this.geoDataCache);
            }
            else if (this.geoServiceSubject) {
                console.log('geo: return geo subject');
                return this.geoServiceSubject;
            }
            else {
                console.log('geo: create geo subject, call geo endpoint, return geo subject');
                this.geoServiceSubject = new Subject();
                this.httpClient.get(this.url).subscribe(function (geodata) {
                    console.log('geo: received geo data, caching calling next on geo subject');
                    _this.geoDataCache = geodata;
                    _this.geoServiceSubject.next(geodata);
                });
                return this.geoServiceSubject;
            }
        }
    };
    GeolocationService.prototype.getGeoFromCookie = function (cookie) {
        var geoip = JSON.parse(unescape(cookie));
        return of(geoip);
    };
    GeolocationService.prototype.getGeoFromAkamaiCookie = function (cookie) {
        var geoip = JSON.parse(unescape(cookie));
        // lc to match existing format
        geoip.countryIsoCode = geoip.countryisocode = geoip.country.toLowerCase();
        // use iso->country map if it exists
        geoip.country = this.config.ISO_COUNTRY_MAP[geoip.country] || geoip.country;
        // use region map if it exists
        geoip.region = this.config.REGION_MAP[geoip.region] || geoip.region;
        // convert Akamai format: 'Los Angeles' to `los+angeles'
        geoip.metro = geoip.metro.toLowerCase().replace(' ', '+');
        // Akamai sends ranges/lists of zip codes
        // example: `91501-91508+91510+91521-91523+91526`
        // only get the first zip code
        var match = geoip.zipCode.match(/^\d+/);
        if (match) {
            geoip.zipCode = match[0];
        }
        return of(geoip);
    };
    GeolocationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GeolocationService_Factory() { return new GeolocationService(i0.ɵɵinject(GEO_LOCATION_CONFIG), i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.CookieService)); }, token: GeolocationService, providedIn: "root" });
    return GeolocationService;
}());
export { GeolocationService };
